import api from "@/app/api";
import { useApiCall } from "@/app/api/apiCall";
import { Link } from "@/app/components/Link";
import { SubmitButton } from "@/app/components/SubmitButton";
import { Unauth } from "@/app/components/Unauth";
import { useStandardToast } from "@/app/hooks/useStandardToast";
import { Text } from "@chakra-ui/react";
import { Form, FormLayout } from "@saas-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router";

interface ForgotPasswordPayload {
  email: string;
  password: string;
}

export default function ForgotPassword() {
  const [isResetting, setIsResetting] = useState<boolean>(false);
  const navigate = useNavigate();
  const toast = useStandardToast();
  const handle = useApiCall();

  const onSubmit = async (payload: ForgotPasswordPayload) => {
    setIsResetting(true);
    await handle(
      () => api.requestPasswordResetTokenEmail(payload),
      () => {
        navigate("/login");
        toast({
          title: "Please check your inbox for reset password instructions",
          status: "success",
        });
      },
      () => setIsResetting(false)
    );
  };

  return (
    <Unauth
      form={
        <Form onSubmit={onSubmit} defaultValues={{ email: undefined }}>
          {({ Field }) => (
            <FormLayout>
              <Field
                name="email"
                label="Email address"
                disabled={isResetting}
                type="text"
                rules={{
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Please enter a valid email address",
                  },
                  required: "Email address is required.",
                }}
              />
              <SubmitButton isDisabled={isResetting}>
                Send reset password email
              </SubmitButton>
            </FormLayout>
          )}
        </Form>
      }
      footer={
        <Text fontSize="xs">
          <Link to="/login" data-cy="login-link">
            Back to login
          </Link>
        </Text>
      }
    />
  );
}
